import { Stack, StackProps } from '@mui/material';

export const CenterStack = ({ children, ...props }: StackProps) => {
  return (
    <Stack
      {...props}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      {children}
    </Stack>
  );
};
